import { AI_MESSAGE_TYPE, AI_ROLE, AI_INTERACTION_TYPE } from '~/stores/aiAssistantTypes';
import type { AiMessage, AiInteractionType, AiRole } from '~/stores/aiAssistantTypes';

interface BackendMessage {
    role: 'user' | 'assistant';
    content: string;
    type: 'text' | 'interactive';
    interaction_type?: string;
    options?: Array<{ label: string; value: string }>;
    selected?: string | null;
    selected_label?: string | null;
    free_line_data?: { title: string; price: number; quantity: number; unit: string; vatRate: string } | null;
    dismissed?: boolean;
    document_created?: Array<{ type: string; id: string }> | { type: string; id: string } | null;
    narration?: boolean;
    bubble_intro?: string | null;
    auto_fix?: { applied: boolean; dismissed?: boolean } | null;
    created_at?: string;
}

/**
 * Convert backend-formatted messages to frontend AiMessage format.
 * The backend now handles all parsing (interactive extraction, selection matching,
 * content cleaning) so the frontend just maps the shape.
 */
export const parseHistoryMessages = (messages: BackendMessage[]): AiMessage[] => {
    return messages.map((msg) => {
        if (msg.type === 'interactive') {
            return {
                id: crypto.randomUUID(),
                role: AI_ROLE.ASSISTANT,
                content: msg.content,
                type: AI_MESSAGE_TYPE.INTERACTIVE,
                timestamp: msg.created_at ? new Date(msg.created_at) : new Date(),
                interactionType: (msg.interaction_type as AiInteractionType) ?? AI_INTERACTION_TYPE.RADIO,
                options: msg.options ?? [],
                optionSelected: (msg.selected !== null && msg.selected !== undefined) || !!msg.dismissed,
                selectedLabel: msg.selected_label ?? null,
                freeLineData: msg.free_line_data ?? null,
            };
        }

        return {
            id: crypto.randomUUID(),
            role: msg.role as AiRole,
            content: msg.content,
            type: AI_MESSAGE_TYPE.TEXT,
            documentCreated: msg.document_created
                ? (Array.isArray(msg.document_created) ? msg.document_created : [msg.document_created])
                : null,
            narration: msg.narration ?? false,
            bubbleIntro: msg.bubble_intro ?? null,
            autoFix: msg.auto_fix ?? null,
            timestamp: msg.created_at ? new Date(msg.created_at) : new Date(),
        };
    });
};
